import Footer from "../Footer";
import Navbar from "../Navbar";
import SEO from "../SEO";

const InterestRatePolicy: React.FC = () => {
  const policySections = [
    {
      title: `1. ${import.meta.env.VITE_COMPANY_NBFC} (Brand Name: ${import.meta.env.VITE_COMPANY_NAME})`,
      content: `The Reserve Bank of India (RBI) through its notification DNBS.204/CGM (ASR)-2009 dated January 2, 2009, and the Master Direction DNBR. PD. 007/03.10.119/2016-17 dated September 1, 2016, directs NBFCs and their Boards to review and implement internal interest rate models that factor in the cost of funds, margin, and risk premium. ${import.meta.env.VITE_COMPANY_NBFC} ("Company"), operating under the brand "${import.meta.env.VITE_COMPANY_NAME}," complies with these guidelines and has formulated this Interest Rate Policy in line with the Fair Practices Code.`,
    },
    {
      title: "2. Disclosure",
      content: `The Company's interest rate determination process—including applicable rates and charges—is transparently disclosed on its official website and shared with customers during the loan process.`,
    },
    {
      title: "3. Interest Rate",
      list: [
        "This policy is approved by the Board of Directors and incorporates key factors: cost of funds, margin, and risk premium.",
        "Rates vary by borrower based on risk profile, credit score, and operational costs.",
        "Loan amounts range from ₹5,000 to ₹1,00,000 with tenures between 7 days and 3 months.",
        "Maximum annual rates for Q4 FY2025: 108% (Personal loans), 510.25% (Salary Advance loans).",
        "Target maximum rates for Q4 FY2026: 72% (Personal loans), 382.5% (Salary Advance loans).",
        "All loans are Fixed Rate and repaid through EMIs or Bullet repayment. Interest is payable on due date; penal interest applies for delays.",
      ],
    },
    {
      title: "4. Fees & Charges",
      list: [
        "Borrowers pay fees such as processing, credit assessment, or origination (10–15% of loan amount).",
        "Additional charges apply for EMI returns, rescheduling, or special services.",
        "Applicable taxes and cesses are levied as per law, and all revisions are prospective.",
        "Refunds or waivers may be granted solely at the Company's discretion.",
      ],
    },
    {
      title: "5. Customer Communication",
      content:
        "The final interest rate, applicable fees, and charges are clearly communicated to the borrower at loan sanction through a Sanction Letter and loan documentation. Borrowers receive a copy of the signed loan agreement after disbursal.",
    },
    {
      title: "6. Amendment",
      content:
        "This policy may be revised or updated at any time with the approval of the Board of Directors. All changes, once approved, take immediate effect.",
    },
  ];

  return (
    <div className="min-h-screen bg-white text-text-primary font-mono selection:bg-secondary selection:text-white ">
      <SEO
        title="Interest Rate Policy"
        description={`Official interest rate determination model for ${import.meta.env.VITE_COMPANY_NAME}. Transparency in cost of funds, margin, and risk premium models.`}
        keywords={`interest rate policy, NBFC interest rates, loan charges, ${import.meta.env.VITE_COMPANY_NAME} rates`}
      />
      <Navbar />

      {/* Official Registry Hero */}
      <section className="w-full bg-text-primary py-32 md:py-48 text-center px-6 relative overflow-hidden border-b-8 border-secondary mb-24">
        <div className="absolute inset-0 opacity-[0.05] pointer-events-none"
          style={{ backgroundImage: `linear-gradient(#fff 1px, transparent 1px), linear-gradient(90deg, #fff 1px, transparent 1px)`, backgroundSize: '40px 40px' }} />

        <div className="relative z-10 max-w-5xl mx-auto">
          <div className="inline-flex items-center gap-4 px-6 py-2 bg-white/5 border border-white/10 text-secondary text-[10px] font-black uppercase tracking-[0.5em] mb-12">
            <div className="w-2 h-2 bg-secondary animate-pulse" />
            Lending_Archive_Protocol_v4.2
          </div>
          <h1 className="text-5xl md:text-[6rem] font-black tracking-tighter leading-[0.85] mb-12 uppercase text-white italic">
            Interest Rate <span className="text-secondary not-italic">Policy.</span>
          </h1>
          <p className="text-white/60 text-lg md:text-2xl max-w-3xl mx-auto font-bold leading-relaxed border-y border-white/10 py-10 uppercase tracking-tight">
            Institutional standards for responsible lending. <br />
            <span className="text-white">Administered in accordance with Reserve Bank of India guidelines.</span>
          </p>
        </div>
      </section>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 pb-40">
        <div className="border-t-4 border-text-primary">
          {policySections.map((section, idx) => (
            <div key={idx} className="border-b border-text-primary/10 py-16 group">
              <div className="flex flex-col gap-10">
                <div className="flex items-start gap-8">
                  <span className="text-secondary font-black text-xs pt-1">SEC_00{idx + 1}</span>
                  <h2 className="text-3xl md:text-5xl font-black text-text-primary leading-tight uppercase tracking-tighter italic">
                    {section.title.split('. ')[1] || section.title}
                  </h2>
                </div>

                <div className="pl-16 md:pl-24 space-y-8">
                  {section.content && (
                    <p className="text-text-secondary font-bold text-lg leading-relaxed uppercase tracking-tight border-l-4 border-text-primary/5 pl-8 italic">
                      {section.content}
                    </p>
                  )}
                  {section.list && (
                    <ul className="space-y-6">
                      {section.list.map((li, i) => (
                        <li key={i} className="flex items-start gap-4 text-text-primary font-bold text-base leading-relaxed">
                          <div className="w-2 h-2 bg-secondary mt-2 shrink-0" />
                          <span className="uppercase tracking-tight">{li}</span>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default InterestRatePolicy;
